module.exports = __webpack_public_path__ + "static/media/fr.f689ce44.svg";